import type { ACPStatus } from "@/lib/types/acp";
import { Badge2 } from "@/ui2/atoms/Badge";

type StatusBadgeProps = {
  status: ACPStatus;
};

export function AcpStatusBadge({ status }: StatusBadgeProps) {
  switch (status) {
    case "NOT_ELIGIBLE":
      return <Badge2 variant="neutral">Not Eligible</Badge2>;

    case "OPTED_IN":
      return <Badge2 variant="success">Opted-in</Badge2>;

    case "OPTED_OUT":
      return <Badge2 variant="error">Opted-out</Badge2>;

    case "NOT_RESPONDED":
      return <Badge2 variant="neutral">No Response</Badge2>;

    default:
      return null;
  }
}
